




import {Component, Prop, Vue} from 'vue-property-decorator'
import {ChartData, ChartOptions} from 'chart.js'
import {PerformanceData} from '@/domain/PMStrategyPerformance'
import PerformanceChartBase from '@/components/PerformanceChartBase.vue'

@Component({
  components: {PerformanceChartBase},
})
export default class ExposureRadar extends Vue {
  @Prop()
  private isSp!: boolean

  private options: ChartOptions = {
    responsive: true,
    legend: {
      display: false,
    },
    scales: {
      yAxes: [{
        gridLines: {
          color: 'rgba(0,0,0,0)',
          zeroLineColor: '#DADADA',
        },
        ticks: {
          callback(value: number | string,
                   index: number,
                   values: number[] | string[],
          ): string | number | null | undefined {
            const label = value.toLocaleString()
            if (index === 0) {
              // @ts-ignore
              return ['（万円）', label]
            }
            return label
          },
          fontSize: this.isSp ? 10 : 16,
          maxTicksLimit: 5,
        },
      }],
      xAxes: [{
        gridLines: {
          color: 'rgba(0,0,0,0)',
          zeroLineColor: '#DADADA',
        },
        ticks: {
          maxTicksLimit: 5,
          fontSize: this.isSp ? 10 : 16,
          padding: 10,
          maxRotation: 30,
          minRotation: 10,
        },
      }],
    },
    tooltips: {
      titleFontSize: this.isSp ? 12 : 16,
      bodyFontSize: this.isSp ? 12 : 16,
      enabled: false,
    },
  }

  @Prop()
  private performanceData!: PerformanceData[]

  @Prop()
  private width!: number

  @Prop()
  private height!: number

  get chartData(): ChartData {
    return {
      labels: this
          .performanceData
          .map((d) => d.date.format('YY/MM')),
      datasets: [
        { // main
          data: this
              .performanceData
              .map((d) => Number((d.value / 10000).toFixed(1))),
          borderColor: '#4CB3ED',
          borderWidth: this.isSp ? 2 : 4,
          pointBackgroundColor: 'rgba(0,0,0,0)',
          pointBorderColor: 'rgba(0,0,0,0)',
          pointBorderWidth: 0,
          pointRadius: 5,
          fill: false,
          order: 1,
          lineTension: 0.2,
          label: 'pm',
        },
        { // main
          data: this
              .performanceData
              .map((d) => Number((d.bookValue / 10000).toFixed(1))),
          borderColor: 'rgba(220, 220, 220, 1)',
          borderWidth: this.isSp ? 2 : 3,
          pointBackgroundColor: 'rgba(0,0,0,0)',
          pointBorderColor: 'rgba(0,0,0,0)',
          pointBorderWidth: 0,
          pointRadius: 5,
          fill: false,
          order: 1,
          label: 'deposit',
        },
      ],
    }
  }
}
